<template>
    <vue-echarts :option="option" class="chart w-full h-full" autoResize />
</template>

<script setup>
import { VueEcharts } from 'vue3-echarts';
import { onMounted, ref, computed } from 'vue'
const props = defineProps({

  seriesData:{
    type: Array,
    default: ()=> []
  },
})

const option = computed(()=>{
    return{
        /*tooltip: {
            trigger: 'item',
            confine: 'true',
            textStyle: {
                fontFamily: 'kanit',
                fontWeight: '400',
                color: '#fff'
            },
            backgroundColor: 'rgba(0,0,0, .8)',
            borderColor: 'rgba(0,0,0, .8)',
            valueFormatter: (value) => new Intl.NumberFormat().format(value),
        },*/
        radar: {
            indicator: [
                {
                    name: ["ครอบครัวคู่รัก\nเพศเดียวกัน", props.seriesData[0]],
                    max: Math.max(...props.seriesData),
                    // min: 0

                },
                {
                    name: ["ครอบครัวผสม", props.seriesData[1]],
                    max: Math.max(...props.seriesData),
                    // min: 0
                },
                {
                    name: ["อยู่คนเดียว", props.seriesData[2]],
                    max: Math.max(...props.seriesData),
                    // min: 0
                },
                {
                    name: ["ครอบครัวขยาย", props.seriesData[3]],
                    max: Math.max(...props.seriesData),
                    // min: 0
                },
                {
                    name: ["ครอบครัววัยรุ่น", props.seriesData[4]],
                    max: Math.max(...props.seriesData),
                    // min: 0
                },
                {
                    name: ["ครอบครัวเดี่ยว", props.seriesData[5]],
                    max: Math.max(...props.seriesData),
                    // min: 0
                },
                {
                    name: ["ครอบครัวข้ามรุ่น", props.seriesData[6]],
                    max: Math.max(...props.seriesData),
                    // min: 0
                },
                {
                    name: ["ครอบครัวพ่อแม่\nเลี้ยงเดี่ยว", props.seriesData[7]],
                    max: Math.max(...props.seriesData),
                    // min: 0
                },
                {
                    name: ["ครอบครัวผู้สูงอายุ\nอยู่ด้วยกันตามลำพัง", props.seriesData[8]],
                    max: Math.max(...props.seriesData),
                    // min: 0
                }
            ],
            axisLabel: {},
            axisLine: {
                show: false
            },
            splitArea :{
                show: false
            },
            radius:'53%',
            nameGap: 13,
            axisName: {
                fontSize: 10,
                color: 'rgba(113,128,150)',
                borderRadius: 3,
                padding: [3, 5],
                formatter: function (value) {
                    return value[0]+'\n{total|'+new Intl.NumberFormat().format(value[1])+'}'
                },
                rich: {
                    total: {
                        color: '#204180',
                        fontSize: 14,
                        lineHeight: 26
                    },
                }
            }
        },
        textStyle: {
            fontFamily: 'kanit',
            fontWeight: 'normal'
        },
        series: [{
            type: "radar",
            data: [
                {
                    name:"",
                    value: props.seriesData,
                    symbolSize: 5,
                    areaStyle: {
                        color: '#2e9de7',
                        opacity: 1
                    },
                    itemStyle:{
                        color: "#2e9de7"
                    },
                    lineStyle:{
                        width: 2,
                        color: '#2e9de7'
                    },
                    indicatorName: [["abbb","nnnn"],"b"]
                }
            ],
        }]
    }
})
</script>

<style lang="scss">
.chart {
    max-height: 400px;
    @media (min-width: 640px) and (max-width: 1023px) {
        max-height: 600px;
    }
}

</style>